import { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import toast from "react-hot-toast";
import { setFechaPagoSueldo, eliminarFechaPagoSueldo } from "../../utils/pagosEmpleados";

// Override de la fecha de pago del sueldo líquido de un empleado/mes en la proyección (FASE 8.2).
// Escribe en pago_sueldo_fecha (upsert) o borra el override (→ vuelve al último día del mes).
// Solo se abre desde el lápiz dedicado del tab RRHH, gateado por esGerente(userId).

const MESES = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre",
];

const formatFechaLarga = (fechaStr) => {
  if (!fechaStr) return "—";
  const f = fechaStr.includes("T") ? fechaStr.substring(0, 10) : fechaStr;
  const [yyyy, mm, dd] = f.split("-");
  return `${dd}/${mm}/${yyyy}`;
};

const EditarFechaSueldoModal = ({ show, onHide, entry, onSaved }) => {
  const [fecha, setFecha] = useState(entry?.fecha_display || "");
  const [guardando, setGuardando] = useState(false);

  if (!entry) return null;

  const periodoLabel = `${MESES[entry.periodo_mes - 1]} ${entry.periodo_año}`;

  const handleGuardar = async () => {
    if (!fecha) {
      toast.error("Seleccioná una fecha");
      return;
    }
    setGuardando(true);
    try {
      await setFechaPagoSueldo(entry.empleado_id, entry.periodo_año, entry.periodo_mes, fecha);
      toast.success("Fecha de pago actualizada");
      onSaved?.();
    } catch (e) {
      toast.error(`Error al guardar: ${e.message || e}`);
    } finally {
      setGuardando(false);
    }
  };

  const handleRestaurar = async () => {
    setGuardando(true);
    try {
      await eliminarFechaPagoSueldo(entry.empleado_id, entry.periodo_año, entry.periodo_mes);
      toast.success("Restaurada al fin de mes");
      onSaved?.();
    } catch (e) {
      toast.error(`Error al restaurar: ${e.message || e}`);
    } finally {
      setGuardando(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: "1.1rem" }}>Editar fecha de pago del sueldo</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ fontSize: "0.9rem", lineHeight: 1.7, marginBottom: 16 }}>
          <div>
            <strong>Empleado:</strong> {entry.razon_social_receptor || "—"}
          </div>
          <div>
            <strong>Período:</strong> {periodoLabel}
          </div>
          <div>
            <strong>Fecha por defecto:</strong> {formatFechaLarga(entry.fecha_default)}
            <span style={{ color: "#888", marginLeft: 6, fontSize: "0.8rem" }}>(fin de mes)</span>
          </div>
          <div>
            <strong>Fecha efectiva actual:</strong> {formatFechaLarga(entry.fecha_display)}
            <span style={{ color: "#888", marginLeft: 6, fontSize: "0.8rem" }}>
              {entry.tiene_override ? "(override)" : "(sin override)"}
            </span>
          </div>
        </div>

        <Form.Group>
          <Form.Label style={{ fontWeight: 600, fontSize: "0.9rem" }}>Nueva fecha de pago</Form.Label>
          <Form.Control type="date" value={fecha} onChange={(e) => setFecha(e.target.value)} disabled={guardando} />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer style={{ justifyContent: "space-between" }}>
        <div>
          {entry.tiene_override && (
            <Button variant="outline-secondary" size="sm" onClick={handleRestaurar} disabled={guardando}>
              Restaurar fin de mes
            </Button>
          )}
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          <Button variant="secondary" size="sm" onClick={onHide} disabled={guardando}>
            Cerrar
          </Button>
          <Button variant="primary" size="sm" onClick={handleGuardar} disabled={guardando}>
            {guardando ? "Guardando…" : "Guardar"}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default EditarFechaSueldoModal;
